<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select :items="types" label="Contact Type" v-model="newType" :rules="requiredRules"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field label="Name" v-model="newName" :rules="requiredRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                            v-model="newAddress"
                                            label="Address"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            v-model="newCity"
                                            label="City"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            v-model="newState"
                                            label="State"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" class="mb-16">
                                        <v-text-field
                                            v-model="newZipCode"
                                            label="Zip Code"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="newCellPhone"
                                            label="Cell Phone"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="newEmail"
                                            label="Email"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="newType === 'Employer'">
                                        <v-text-field
                                            v-model="newEmploymentStatus"
                                            label="Employment Status"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="newType === 'Employer'">
                                        <v-text-field v-model="newEmployer" label="Employer Name"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="newType === 'Employer'">
                                        <v-text-field v-model="newJobTitle" label="Job Title"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3" v-if="newType === 'Employer'">
                                        <v-text-field
                                            v-model="newEmploymentDuration"
                                            label="Employment Duration"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" v-if="newType === 'Employer'">
                                        <v-text-field v-model="newEmpAddress" label="Employer Address"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" v-if="newType === 'Employer'">
                                        <v-text-field v-model="newEmpCity" label="Employer City"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" v-if="newType === 'Employer'">
                                        <v-text-field v-model="newEmpState" label="Employer State"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4" v-if="newType === 'Employer'">
                                        <v-text-field
                                            v-model="newEmpZipCode"
                                            label="Employer Zip Code"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" v-if="newType === 'Employer'">
                                        <v-text-field
                                            v-model="newEmpPhone"
                                            label="Employer Phone Number"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!newContactInfo"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addContactInfo()"
                            v-if="newContactInfo"
                        >
                            Save
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="updateContactInfo()"
                            v-if="!newContactInfo"
                        >
                            Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>


<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import {displayError, displaySuccess} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";


const url = require("../../../client_config/config").url;

export default {
    components: {
        ClientNav,
        Foot,
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Name",
                    align: "start",
                    sortable: false,
                    value: "Name",
                },
                {text: "Phone", value: "CellPhone"},
                {text: "Email", value: "Email"},
                {text: "Address", value: "Address"},
                {text: "City", value: "City"},
                {text: "State", value: "State"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            newContactInfo: false,
            contactInfo: {},
            users: [],
            types: [
                "Guardian",
                "Mother",
                "Father",
                "Emergency Contact",
                "Employer",
            ],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem("userID"),
            contactInfoId: this.$route.params.id,
            token: localStorage.getItem('token'),
            tempData: [],
            titleForm: "New Contact Information",
            contactinfoID: "",
            newType: "",
            newName: "",
            newAddress: "",
            newCity: "",
            newState: "",
            newZipCode: "",
            newCellPhone: "",
            newEmail: "",
            newEmploymentStatus: "",
            newEmployer: "",
            newJobTitle: "",
            newEmploymentDuration: "",
            newEmpAddress: "",
            newEmpCity: "",
            newEmpState: "",
            newEmpZipCode: "",
            newEmpPhone: "",
            editedIndex: -1,
            editedItem: {
                address: "",
                city: "",
                state: "",
                zipCode: "",
                cellPhone: "",
                employmentStatus: "",
                employer: "",
                jobTitle: "",
                employmentDuration: "",
                empAddress: "",
                empCity: "",
                empState: "",
                empZipCode: "",
                empPhone: "",
            },
            defaultItem: {
                address: "",
                city: "",
                state: "",
                zipCode: "",
                cellPhone: "",
                employmentStatus: "",
                employer: "",
                jobTitle: "",
                employmentDuration: "",
                empAddress: "",
                empCity: "",
                empState: "",
                empZipCode: "",
                empPhone: "",
            },
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
        };
    },

    computed: {},

    watch: {},

    created() {
        this.newContactInfo = this.$route.query.newContactInfo === 'true'
    },

    mounted() {
        if (!this.newContactInfo) {
            this.getContactInfo();
        }
        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.contactInfoId, this.token,'ContactInfo');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.contactInfoId, this.token,'ContactInfo');
        });
    },

    methods: {

        initialize() {
            this.contactInfos = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewContactInfo(item) {

            this.newType = item.Type;
            this.newName = item.Name;
            this.newAddress = item.Address;
            this.newCity = item.City;
            this.newState = item.State;
            this.newZipCode = item.ZipCode;
            this.newCellPhone = item.CellPhone;
            this.newEmail = item.Email;
            this.newEmploymentStatus = item.EmploymentStatus;
            this.newEmployer = item.Employer;
            this.newJobTitle = item.JobTitle;
            this.newEmploymentDuration = item.EmploymentDuration;
            this.newEmpAddress = item.EmpAddress;
            this.newEmpCity = item.EmpCity;
            this.newEmpState = item.EmpState;
            this.newEmpZipCode = item.EmpZipCode;
            this.newEmpPhone = item.EmpPhone;
            this.contactInfoId = item._id;
        },

        close() {
            this.$router.go(-1);
            this.clear()
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async updateContactInfo() {
            if (this.validate()) {
                let req_body = {
                    Type: this.newType,
                    Name: this.newName,
                    Address: this.newAddress,
                    City: this.newCity,
                    State: this.newState,
                    ZipCode: this.newZipCode,
                    CellPhone: this.newCellPhone,
                    Email: this.newEmail,
                    EmploymentStatus: this.newEmploymentStatus,
                    Employer: this.newEmployer,
                    JobTitle: this.newJobTitle,
                    EmploymentDuration: this.newEmploymentDuration,
                    EmpAddress: this.newEmpAddress,
                    EmpCity: this.newEmpCity,
                    EmpState: this.newEmpState,
                    EmpZipCode: this.newEmpZipCode,
                    EmpPhone: this.newEmpPhone,
                };

                try {
                    const response = await axios.put(`${url}/contactInfo/${this.contactInfoId}`, req_body);
                    this.getContactInfos();

                    if (response.status !== 200) {
                        displayError("There was an error updating the document.");
                        return;
                    }

                    displaySuccess("The contact info has been updated successfully.");
                    this.getContactInfos();
                } catch (error) {
                    displayError(error.response && error.response.data && error.response.data.msg || "An unexpected error occurred.");
                } finally {
                    this.isLoading = false;
                    this.close();
                }
            } else {
                displayError("Please fill in all required, fields.");
            }
        },


        getContactInfo() {
            this.isLoading = true;
            axios
                .get(`${url}/contactInfo/${this.contactInfoId}`)
                .then((res) => {
                    this.contactInfo = res.data.clientInfo;
                    this.viewContactInfo(this.contactInfo);
                    // for (var i = 0; i < this.tempData.length; i++) {
                    //     if (this.tempData[i].ClientID === this.clientID) {
                    //         this.contactInfos.push(this.tempData[i]);
                    //     }
                    // }
                })
                .finally(() => (this.isLoading = false));
        },

        getContactInfos() {
            this.isLoading = true;
            axios
                .get(`${url}/contactInfo`)
                .then((res) => {
                    this.contactInfos = [];
                    this.tempData = res.data.clientInfos;
                    for (var i = 0; i < this.tempData.length; i++) {
                        if (this.tempData[i].ClientID === this.clientID) {
                            this.contactInfos.push(this.tempData[i]);
                        }
                    }
                })
                .finally(() => (this.isLoading = false));
        },

        getUsers: function () {
            axios.get(`${url}/users`).then(async (res) => {
                this.users = res.data.users;
            });
        },

        async addContactInfo() {
            if (this.validate()) {
                let req_body = {
                    Name: this.newName,
                    Address: this.newAddress,
                    Email: this.newEmail,
                    Type: this.newType,
                    City: this.newCity,
                    State: this.newState,
                    ZipCode: this.newZipCode,
                    CellPhone: this.newCellPhone,
                    EmploymentStatus: this.newEmploymentStatus,
                    Employer: this.newEmployer,
                    JobTitle: this.newJobTitle,
                    EmploymentDuration: this.newEmploymentDuration,
                    EmpAddress: this.newEmpAddress,
                    EmpCity: this.newEmpCity,
                    EmpState: this.newEmpState,
                    EmpZipCode: this.newEmpZipCode,
                    EmpPhone: this.newEmpPhone,
                    ClientID: this.clientID,
                };
                try {
                    const response = await axios.post(`${url}/contactInfo`, req_body);
                    this.getContactInfos();

                    if (response.status !== 200) {
                        displayError("There was an error adding the document.");
                        return;
                    }

                    displaySuccess("The contact information has been added successfully.");
                    this.getContactInfos()

                } catch (error) {
                    displayError(error.response && error.response.data && error.response.data.msg || "An unexpected error occurred.");
                } finally {
                    this.close();
                }
            } else {
                displayError("Please fill in all required fields.");
            }
        },

        async generateDownloadUrl() {
            return `${url}/contactInfo/print?id=${this.contactInfoId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.contactInfoId, this.token,'ContactInfo');
        },

        clear() {
            this.newType = "";
            this.newName = "";
            this.newAddress = "";
            this.newCity = "";
            this.newState = "";
            this.newZipCode = "";
            this.newCellPhone = "";
            this.newEmail = "";
            this.newEmploymentStatus = "";
            this.newEmployer = "";
            this.newJobTitle = "";
            this.newEmploymentDuration = "";
            this.newEmpAddress = "";
            this.newEmpCity = "";
            this.newEmpState = "";
            this.newEmpZipCode = "";
            this.newEmpPhone = "";
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
